import {
    required,
    TextInput,
    useDataProvider,
    useNotify,
    usePermissions,
    useResourceContext,
    useTranslate,
} from "react-admin";
import { queryToAttribute } from "shared/src/utils/decodeQuery";
import { ToolbarWithHistory } from "shared/src/components/ToolbarWithHistory";
import { SimpleFormWithPermissions } from "../components/SimpleFormWithPermissions";
import { AccessRightsError } from "shared/src/components/AccessRightsError";
import { RaEditView } from "../components/views/RaEditView";
import { AddressFormInput } from "../components/AddressFormInput";
import { transformDataAndUpdateAddress } from "../utils/transformDataAndUpdateAddress";
import { handleHttpError } from "shared/src/utils/errorHandler";

export const SupplierEdit = (props) => {
    const translate = useTranslate();
    const resource = useResourceContext();
    const attribute = queryToAttribute();
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const { isLoading, permissions } = usePermissions();

    if (isLoading) {
        return <></>;
    } else if (!permissions.vote({ resource, attribute })) {
        return <AccessRightsError />;
    }
    return (
        <RaEditView
            transform={(data) =>
                transformDataAndUpdateAddress(data, dataProvider, (e) =>
                    handleHttpError(e, notify)
                )
            }
            mutationMode="pessimistic"
            {...props}
            actions={<ToolbarWithHistory back={true} show={true} />}
        >
            <SimpleFormWithPermissions>
                <TextInput
                    title={translate("equip.name")}
                    label="equip.name"
                    source="name"
                    validate={[required()]}
                />
                <AddressFormInput />
            </SimpleFormWithPermissions>
        </RaEditView>
    );
};
